import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-not-authorised',
    templateUrl: './not-authorised.component.html',
    styleUrls: ['./not-authorised.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, TranslateModule]
})
export class NotAuthorisedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
